import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import { API_ENDPOINTS, METHOD_TYPE } from "../../utils/apiUrls";
import api from "../../utils/api";


const initialState = {
    isLoading: false,
    error: null,
    OomeroEntity:[],

}

export const sendPostPaidClientLink = createAsyncThunk("user/sendPostPaidClientLink", async (requestObject) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.sendPostPaidClientLink,
            data: requestObject
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const onboardPostpaidEntity = createAsyncThunk("user/onboardPostpaidEntity", async (payload) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.onboardPostpaidEntity,
            data: payload
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const setPostPaidClientPassword = createAsyncThunk("user/setPostPaidClientPassword", async (requestObject) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.setPostPaidClientPassword,
            data: requestObject
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});
export const resendPostpaidInvite = createAsyncThunk("user/resendPostpaidInvite", async (requestObject) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.resendPostpaidInvite,
            data: requestObject
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});
export const fetchOomeroEntity = createAsyncThunk("user/fetchOomeroEntity", async (requestObject) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.fetchOomeroEntity,
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

const onbaordingSliceInfo = createSlice({
    name: "onbaordingSliceInfo",
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendPostPaidClientLink.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(onboardPostpaidEntity.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(resendPostpaidInvite.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(fetchOomeroEntity.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.OomeroEntity = payload.data;
                state.error = null;
            })
            .addMatcher(isAnyOf(sendPostPaidClientLink.pending, onboardPostpaidEntity.pending,fetchOomeroEntity.pending,resendPostpaidInvite.pending), (state) => {
                state.isLoading = true;
            })
            .addMatcher(isAnyOf(sendPostPaidClientLink.rejected, onboardPostpaidEntity.rejected,fetchOomeroEntity.rejected,resendPostpaidInvite.rejected), (state, { error }) => {
                state.isLoading = false;
                state.error = error.message ? error.message : "Request Failed Please Try Again ";
            })
    }
});

const onboardingInfoSlice = onbaordingSliceInfo.reducer;

export default onboardingInfoSlice;